import type { Value, PointTarget, GeometryElementDisplayConfig } from '../../../geometrypad.model';

// =============================================================================
// TYPES
// =============================================================================

export interface ArcElement {
  type: 'Arc';
  params: {
    r?: Value;
    center?: PointTarget;
    startAngle?: Value;
    endAngle?: Value;
    centralAngle?: Value;
  };
  names?: {
    r?: string;
    arcLength?: string;
    centralAngle?: string;
    chordLength?: string;
    sectorArea?: string;
    segmentArea?: string;
  };
}

// =============================================================================
// DISPLAY DEFAULTS
// =============================================================================

/**
 * Default display theme for arcs.
 *
 * Visible by default: arc curve, center point, both radii, central angle marker.
 * Hidden by default: start/end points (redundant with radii endpoints), chord, sector fill.
 */
export const ARC_DEFAULTS: GeometryElementDisplayConfig = {
  circle: { strokeColor: 'sky', fillOpacity: 0, strokeWidth: 2 },
  point: { color: 'sky', size: 4 },
  line: { strokeWidth: 1.5, color: 'sky' },
  angle: { fillOpacity: 0.15, fillColor: 'sky' },
  subparts: {
    center: { point: { color: 'sky' } },
    start: { visible: false, point: { color: 'sky' } },
    end: { visible: false, point: { color: 'sky' } },
    radiusStart: { line: { color: 'sky', strokeWidth: 1.5 } },
    radiusEnd: { line: { color: 'sky', strokeWidth: 1.5 } },
    centralAngle: { angle: { fillColor: 'sky', fillOpacity: 0.15 } },
    chord: { visible: false, line: { color: 'neutral', strokeWidth: 1 } },
    sector: { visible: false, polygon: { fillColor: 'sky', fillOpacity: 0.1 } },
  },
};
